import { stringify } from 'qs';
import { tokenKey } from '~/constants';

export default defineNuxtPlugin(() => {
  const token = useStatefulCookie(tokenKey);
  const runtimeConfig = useRuntimeConfig();

  const api = $fetch.create({
    baseURL: runtimeConfig.public.ppApiUrl,
    retry: 0,
    onRequest({ options }) {
      if (token.value) {
        const headers = (options.headers ||= {});
        if (Array.isArray(headers)) {
          headers.push(['Authorization', `Bearer ${token.value}`]);
          headers.push(['Accept', 'application/json']);
        } else if (headers instanceof Headers) {
          headers.set('Authorization', `Bearer ${token.value}`);
          headers.set('Accept', 'application/json');
        } else {
          headers.Authorization = `Bearer ${token.value}`;
          headers.Accept = 'application/json';
        }
      }

      if (options.params) {
        const convertedOptions = new URLSearchParams(stringify(options.params));
        options.params = Object.fromEntries(convertedOptions);
      }
    },
    onResponseError(error) {
      const status = error.response.status;
      const isLoginRequest = error.response.url.includes('login');

      if (status === 401) {
        console.log('Unauthorized');

        if (isLoginRequest) {
          return;
        }
      }

      if (status === 404) {
        console.log('Page not found');

        throw createError({
          statusCode: 404,
          message: 'Resource not found',
        });
      }

      if (status === 403) {
        console.log('Access denied');

        throw createError({
          statusCode: 403,
          message: 'Access denied',
        });
      }
    },
  });

  return {
    provide: {
      api,
    },
  };
});
